import { render, staticRenderFns } from "./sosInfo.vue?vue&type=template&id=6f68a617&scoped=true&"
import script from "./sosInfo.vue?vue&type=script&lang=js&"
export * from "./sosInfo.vue?vue&type=script&lang=js&"
import style0 from "./sosInfo.vue?vue&type=style&index=0&id=6f68a617&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f68a617",
  null
  
)

export default component.exports